var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.668 6.66846H30.0013C30.8854 6.66846 31.7332 7.01965 32.3583 7.64477C32.9834 8.26989 33.3346 9.11774 33.3346 10.0018V33.3351C33.3346 34.2192 32.9834 35.067 32.3583 35.6921C31.7332 36.3173 30.8854 36.6685 30.0013 36.6685H10.0013C9.11725 36.6685 8.2694 36.3173 7.64428 35.6921C7.01916 35.067 6.66797 34.2192 6.66797 33.3351V10.0018C6.66797 9.11774 7.01916 8.26989 7.64428 7.64477C8.2694 7.01965 9.11725 6.66846 10.0013 6.66846H13.3346",
    stroke: "#2D2C2C",
    strokeWidth: 2.13327,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0026 3.3335H15.0026C14.0821 3.3335 13.3359 4.07969 13.3359 5.00016V8.3335C13.3359 9.25397 14.0821 10.0002 15.0026 10.0002H25.0026C25.9231 10.0002 26.6693 9.25397 26.6693 8.3335V5.00016C26.6693 4.07969 25.9231 3.3335 25.0026 3.3335Z",
    stroke: "#2D2C2C",
    strokeWidth: 2.13327,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.258fd5086d6dabdff729ec218242bf3d.svg";
export { ForwardRef as ReactComponent };